/**
 * @generated SignedSource<<585ff00e08b16fb246b11138f7d89006>>
 * @relayHash 6e460ac038e243dbc74984a7e17a7720
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6d8a1c1432dd78a309529a8426e9f0e759b0e202139621c928d8dab8a2de74c7

import type { ConcreteRequest } from 'relay-runtime';
export type BulkSetSpacePermissionSpaceType = "COLLABORATION" | "GLOBAL" | "KNOWLEDGE_BASE" | "PERSONAL" | "%future added value";
export type BulkSetSpacePermissionSubjectType = "ACCESS_CLASS" | "GROUP" | "USER" | "%future added value";
export type SpacePermissionType = "ADMINISTER_SPACE" | "ARCHIVE_PAGE" | "ARCHIVE_SPACE" | "COMMENT" | "CREATE_ATTACHMENT" | "CREATE_BLOG" | "CREATE_EDIT_PAGE" | "DELETE_OWN_COMMENT" | "DELETE_SPACE" | "EDIT_BLOG" | "EDIT_NATIVE_CONTENT" | "EXPORT_CONTENT" | "EXPORT_PAGE" | "EXPORT_SPACE" | "MANAGE_CONTENT" | "MANAGE_GUEST_USERS" | "MANAGE_LOOK_AND_FEEL" | "MANAGE_NONLICENSED_USERS" | "MANAGE_PUBLIC_LINKS" | "MANAGE_TEMPLATES" | "MANAGE_USERS" | "REMOVE_ATTACHMENT" | "REMOVE_BLOG" | "REMOVE_COMMENT" | "REMOVE_MAIL" | "REMOVE_OWN_CONTENT" | "REMOVE_PAGE" | "SET_PAGE_PERMISSIONS" | "VIEW_SPACE" | "%future added value";
export type BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation$variables = {
  spacePermissions: ReadonlyArray<SpacePermissionType | null>;
  spaceTypes: ReadonlyArray<BulkSetSpacePermissionSpaceType | null>;
  subjectId: string;
  subjectType: BulkSetSpacePermissionSubjectType;
};
export type BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation$data = {
  readonly bulkSetSpacePermissionAsync: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null;
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }> | null;
    readonly success: boolean;
    readonly taskId: string | null;
  } | null;
};
export type BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation = {
  response: BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation$data;
  variables: BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spacePermissions"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceTypes"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "subjectId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "subjectType"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "spacePermissions",
        "variableName": "spacePermissions"
      },
      {
        "kind": "Variable",
        "name": "spaceTypes",
        "variableName": "spaceTypes"
      },
      {
        "kind": "Variable",
        "name": "subjectId",
        "variableName": "subjectId"
      },
      {
        "kind": "Variable",
        "name": "subjectType",
        "variableName": "subjectType"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v6 = {
  "kind": "ScalarField",
  "name": "taskId"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "BulkSetSpacePermissionAsyncPayload",
        "kind": "LinkedField",
        "name": "bulkSetSpacePermissionAsync",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          },
          (v6/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "BulkSetSpacePermissionAsyncPayload",
        "kind": "LinkedField",
        "name": "bulkSetSpacePermissionAsync",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "6e460ac038e243dbc74984a7e17a7720",
    "id": "6d8a1c1432dd78a309529a8426e9f0e759b0e202139621c928d8dab8a2de74c7",
    "metadata": {},
    "name": "BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation",
    "operationKind": "mutation",
    "text": "mutation BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation($spacePermissions:[SpacePermissionType]!,$spaceTypes:[BulkSetSpacePermissionSpaceType]!,$subjectId:ID!,$subjectType:BulkSetSpacePermissionSubjectType!){bulkSetSpacePermissionAsync(input:{spacePermissions:$spacePermissions,spaceTypes:$spaceTypes,subjectId:$subjectId,subjectType:$subjectType}){success,errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}},taskId}}"
  }
};
})();

(node as any).hash = "3a45909974779c48b1ef1a6ec89f783e";

export default node;
